module.exports = __webpack_public_path__ + "static/media/help_coming_up.d3f620a9.png";